'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getTransitionDuration = getTransitionDuration;
exports.getDialogTransitionProps = getDialogTransitionProps;
exports.getOverlayTransitionProps = getOverlayTransitionProps;

var _times = require('HubStyleTokens/times');

var DEFAULT_MODAL_TRANSITION_TIMEOUT = parseInt(_times.DEFAULT_MODAL_TRANSITION_TIMING, 10);
var SLIDEIN_MODAL_TRANSITION_TIMEOUT = parseInt(_times.SLIDEIN_MODAL_TRANSITION_TIMING, 10);

var NULL_TRANSITION_PROPS = {
  transitionName: 'none',
  transitionAppear: false,
  transitionEnter: false,
  transitionLeave: false
};

var BASE_TRANSITION_PROPS = {
  transitionAppear: true,
  transitionEnter: true,
  transitionLeave: true
};

function getTransitionProps(_ref) {
  var transitionDuration = _ref.transitionDuration,
      transitionName = _ref.transitionName;

  return _extends({}, BASE_TRANSITION_PROPS, {
    transitionName: transitionName,
    transitionAppearTimeout: transitionDuration,
    transitionEnterTimeout: transitionDuration,
    transitionLeaveTimeout: transitionDuration
  });
}

function getDialogTransitionName(_ref2) {
  var use = _ref2.use;

  switch (use) {
    case 'sidebar':
      return 'slidein-from-right';
    default:
      return 'popin';
  }
}

function getOverlayTransitionName(_ref3) {
  var use = _ref3.use;

  switch (use) {
    case 'sidebar':
      return 'slidein-fadein-background';
    default:
      return 'popin-fadein-background';
  }
}

function getTransitionDuration(_ref4) {
  var _use = _ref4._use,
      use = _ref4.use;

  if (_use === 'sidebar' || use === 'sidebar') {
    return SLIDEIN_MODAL_TRANSITION_TIMEOUT;
  }
  return DEFAULT_MODAL_TRANSITION_TIMEOUT;
}

function getDialogTransitionProps(_ref5) {
  var contextual = _ref5.contextual,
      use = _ref5.use;

  if (contextual) {
    return NULL_TRANSITION_PROPS;
  }

  var transitionDuration = getTransitionDuration({ use: use });
  var transitionName = getDialogTransitionName({ use: use });
  return getTransitionProps({ transitionDuration: transitionDuration, transitionName: transitionName });
}

function getOverlayTransitionProps(_ref6) {
  var contextual = _ref6.contextual,
      use = _ref6.use;

  if (contextual) {
    return NULL_TRANSITION_PROPS;
  }

  var transitionDuration = getTransitionDuration({ use: use });
  var transitionName = getOverlayTransitionName({ use: use });
  return getTransitionProps({ transitionDuration: transitionDuration, transitionName: transitionName });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/dialog/ModalDialogTransitions.js
// module id = 167
// module chunks = 0